<template>
    <div @click="$emit('click')" class="profile-current-aroma">

        <h6 class="profile-current-aroma__title">{{ title }}</h6>

        <div
            v-if="currentPerfumeExist"
            class="profile-current-aroma__selected">
            <div :class="pictureClass" class="profile-current-aroma__pic">
                <img v-lazy-load :data-src="picture || getPerfumeNoImage" :alt="alt || title"/>
            </div>
            <div class="profile-current-aroma__name-wrapper">
                <span class="profile-current-aroma__name">{{ name }}</span>
            </div>
        </div>

        <div
            v-else
            class="profile-current-aroma__add">
            <svg-icon name="icon-set-current-aroma"/>
            <span class="profile-current-aroma__button-add">{{ buttonText }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "UserCurrentAroma",
    props: {
        title: {
            type: String,
            default: null
        },
        picture: {
            type: String,
            default: null
        },
        alt: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        buttonText: {
            type: String,
            default: null
        },
        currentPerfumeExist: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['getPerfumeNoImage']),
        pictureClass() {
            return {
                'profile-current-aroma__pic_margin-bottom': this.name.length > 15
            }
        }
    }
}
</script>

<style lang="less">

.profile-current-aroma {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: flex-end;

    border: 1px solid @color-gray-white;
    border-radius: 3px;

    padding-top: rem(10);
    padding-bottom: rem(6);

    height: rem(139);
    width: rem(116);

    position: relative;

    overflow: hidden;

    .animate(box-shadow);

    .hover({
        box-shadow: @menu-desktop-box-shadow-light;
    });

    &__title {
        color: @color-gray-light;
        font-size: rem(10);
        text-align: center;

        margin: 0;
    }

    &__add {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;

        color: @color-violet;
        font-size: rem(12);

        margin-top: rem(14);
        /*height: calc(100% - rem(12));*/

        height: 100%;

        svg {
            height: rem(56);
            width: rem(56);
        }
    }

    &__button-add {
        display: block;

        text-align: center;

        margin-top: auto;
    }

    &__selected {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: flex-end;

        font-size: rem(12);
        text-align: center;

        height: calc(100% - rem(12));
        width: 100%;
    }

    &__pic {
        display: flex;
        align-items: center;
        justify-content: center;

        height: rem(56);
        width: rem(56);

        position: relative;

        overflow: hidden;

        &_margin-bottom {
            margin-bottom: rem(6);
        }

        img {
            height: 100%;
            max-height: 100%;
            max-width: 100%;
        }
    }

    &__name {
        display: flex;
        align-items: flex-end;

        max-width: 85%;

        overflow: hidden;

        .text-ellipsis(2);

        &-wrapper {
            display: flex;
            align-items: flex-end;
            justify-content: center;

            height: rem(36);
            width: 100%;
        }
    }
}
</style>
